export default __webpack_public_path__ + "static/media/smoothie.e138a18b.png";